const STORAGE_KEY = "postPickupSharePrompt";
export const SHARE_PROMPT_EVENT = "post-pickup-share-scheduled";

export function schedulePostPickupSharePrompt({
  orderId,
  eligibleAt,
  delayMs = 2 * 60 * 1000,
  platformSharePoints = 0,
  restaurantSharePoints = 0,
}) {
  const id = String(orderId || "").trim();
  if (!id) return;
  const at = eligibleAt
    ? new Date(eligibleAt).toISOString()
    : new Date(Date.now() + Math.max(0, Number(delayMs) || 0)).toISOString();
  const payload = {
    orderId: id,
    eligibleAt: at,
    platformSharePoints: Math.max(0, Math.floor(Number(platformSharePoints) || 0)),
    restaurantSharePoints: Math.max(0, Math.floor(Number(restaurantSharePoints) || 0)),
  };
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(SHARE_PROMPT_EVENT, { detail: payload }));
  }
}

export function readScheduledSharePrompt() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.orderId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearScheduledSharePrompt() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
